export const contentElementComments = () => ({
  text: '',
  user: '',
  date: new Date(),
  replies: [],
})

/* eslint-disable @typescript-eslint/camelcase */
export const schemaFactory = () => ({
  additional_properties: {
    clipboard: {},
  },
  address: {},
  content_elements: () => ({
    additional_properties: {
      comments: [],
    },
  }),
  credits: {
    by: [],
  },
  description: {
    basic: '',
  },
  geo: {},
  headlines: {
    basic: '',
    mobile: '',
    native: '',
    print: '',
    tablet: '',
    web: '',
    meta_title: '',
  },
  label: {},
  language: '',
  planning: {
    scheduling: {
      planned_publish_date: '',
    },
    additional_properties: {},
  },
  promo_items: {
    basic: {},
    bright: {},
  },
  owner: {
    sponsored: false,
  },
  related_content: {
    basic: [],
  },
  source: {
    system: '',
    name: '', // window.localStorage.getItem('arc.organization') || '',
    source_type: 'staff',
  },
  subheadlines: {
    basic: '',
  },
  subtype: '',
  taxonomy: {
    sites: [],
    tags: [],
  },
  type: 'story',
  workflow: {
    status_code: 1,
  },
})
